export default {
  namespaced: true,
  state: {
    shallContentShowOverlay: false,
    companyLogoBase64:''

  },
  getters: {



  },
  mutations: {
    SET_COMPANY_LOGO(state, value){
      state.companyLogoBase64 = value
    },

    TOGGLE_CONTENT_OVERLAY(state, value) {
      state.shallContentShowOverlay = value !== undefined ? value : !state.shallContentShowOverlay
    },
  },
  actions: {},
}
